/**
 * PDP galeria — vídeo ambient mudo; botão para ativar/silenciar som.
 */
(function () {
  var SVG_OFF =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
    '<path d="M11 5 6 9H3v6h3l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  var SVG_ON =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
    '<path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>';

  function getLabels() {
    var existing = document.querySelector('[data-md-gallery-video-unmute]');
    if (existing) {
      return {
        unmute: existing.dataset.labelUnmute || 'Ativar som',
        mute: existing.dataset.labelMute || 'Silenciar vídeo',
        tap: existing.dataset.labelTap || 'Clique aqui para ativar som',
      };
    }
    return { unmute: 'Ativar som', mute: 'Silenciar vídeo', tap: 'Clique aqui para ativar som' };
  }

  function isUnmuted(cell) {
    var btn = cell && cell.querySelector('[data-md-gallery-video-unmute]');
    return !!(btn && btn.classList.contains('is-unmuted'));
  }

  function applyMuteState(video, cell) {
    if (!(video instanceof HTMLVideoElement)) return;
    cell = cell || video.closest('[data-md-gallery-video-cell]');
    var unmuted = isUnmuted(cell);
    video.muted = !unmuted;
    video.defaultMuted = !unmuted;
    if (unmuted) {
      video.removeAttribute('muted');
    } else {
      video.setAttribute('muted', '');
    }
  }

  function createUnmuteButton() {
    var labels = getLabels();
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'md-pdp__gallery-video-unmute vf-video-mute-cta';
    btn.setAttribute('data-md-gallery-video-unmute', '');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', labels.unmute);
    btn.dataset.labelUnmute = labels.unmute;
    btn.dataset.labelMute = labels.mute;
    btn.dataset.labelTap = labels.tap;

    var inner = document.createElement('span');
    inner.className = 'vf-video-mute-cta__inner';

    var off = document.createElement('span');
    off.className = 'md-pdp__gallery-video-unmute-icon md-pdp__gallery-video-unmute-icon--off';
    off.setAttribute('aria-hidden', 'true');
    off.innerHTML = SVG_OFF;

    var on = document.createElement('span');
    on.className = 'md-pdp__gallery-video-unmute-icon md-pdp__gallery-video-unmute-icon--on';
    on.setAttribute('aria-hidden', 'true');
    on.innerHTML = SVG_ON;

    var text = document.createElement('span');
    text.className = 'vf-video-mute-cta__text';
    text.textContent = labels.tap;

    inner.appendChild(off);
    inner.appendChild(on);
    inner.appendChild(text);
    btn.appendChild(inner);
    return btn;
  }

  function ensureUnmuteButton(cell) {
    if (!cell) return null;
    var frame = cell.querySelector('.md-pdp__gallery-video-frame');
    if (!frame || !frame.querySelector('video')) return null;
    var btn = frame.querySelector('[data-md-gallery-video-unmute]');
    if (!btn) {
      btn = createUnmuteButton();
      frame.appendChild(btn);
    }
    return btn;
  }

  function bindUnmuteButtons(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-md-gallery-video-cell]').forEach(function (cell) {
      ensureUnmuteButton(cell);
    });

    root.querySelectorAll('[data-md-gallery-video-unmute]').forEach(function (btn) {
      if (btn.dataset.mdUnmuteBound === 'true') return;
      btn.dataset.mdUnmuteBound = 'true';

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var cell = btn.closest('[data-md-gallery-video-cell]');
        var video = cell && cell.querySelector('video');
        if (!(video instanceof HTMLVideoElement)) return;

        var unmuted = !btn.classList.contains('is-unmuted');
        btn.classList.toggle('is-unmuted', unmuted);
        btn.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
        btn.setAttribute('aria-label', unmuted ? btn.dataset.labelMute : btn.dataset.labelUnmute);

        applyMuteState(video, cell);

        if (unmuted) {
          video.play().catch(function () {});
        }
      });
    });
  }

  function videoCellsInScope(root) {
    if (!root || root.nodeType !== 1) return [];
    var cells = [];
    if (root.matches && root.matches('[data-md-gallery-video-cell]')) {
      cells.push(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-md-gallery-video-cell]').forEach(function (cell) {
        if (cells.indexOf(cell) === -1) cells.push(cell);
      });
    }
    return cells;
  }

  function attemptAmbientPlay(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    var playAttempt = video.play();
    if (!playAttempt || typeof playAttempt.catch !== 'function') return;
    playAttempt.catch(function () {
      if (video.readyState >= 2) {
        video.play().catch(function () {});
        return;
      }
      var onReady = function () {
        video.removeEventListener('loadeddata', onReady);
        video.removeEventListener('canplay', onReady);
        video.play().catch(function () {});
      };
      video.addEventListener('loadeddata', onReady, { once: true });
      video.addEventListener('canplay', onReady, { once: true });
    });
  }

  function syncAmbientVideos(scope) {
    var root = scope || document;
    videoCellsInScope(root).forEach(function (cell) {
      ensureUnmuteButton(cell);
      var video = cell.querySelector('video');
      if (!(video instanceof HTMLVideoElement)) return;

      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.removeAttribute('controls');
      video.removeAttribute('poster');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.classList.add('md-pdp__gallery-video-player--ambient');

      applyMuteState(video, cell);

      attemptAmbientPlay(video);
    });

    bindUnmuteButtons(root);
  }

  window.VestfirmaGalleryVideoUnmute = {
    bind: bindUnmuteButtons,
    sync: syncAmbientVideos,
    applyMuteState: applyMuteState,
    ensureButton: ensureUnmuteButton,
    createButton: createUnmuteButton,
    isUnmuted: isUnmuted,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAmbientVideos(document);
    });
  } else {
    syncAmbientVideos(document);
  }
})();
